<i18n>
{
	"en": {
		"selectStatus": "Select Status",
		"statusSelected": "All statuses | {count} status selected | {count} statuses selected",
		"cancelled": "Cancelled",
		"draft": "Draft",
		"received": "Received",
		"rejected": "Rejected",
		"ready": "Ready",
		"planned": "Planned",
		"unsuccessful": "Unsuccessful",
		"requested": "Requested",
		"accepted": "Accepted",
		"selectStatus": "Select status",
		"readyForPickup": "Ready for pickup",
		"loaded": "Loaded",
		"unloaded": "Unloaded",
		"goodsTypes": "Goods Types"
	},
	"no": {
		"selectStatus": "Select status",
		"statusSelected": "Alle statuser | {count} status valgt | {count} statuser valgt",
		"cancelled": "Annullert",
		"draft": "Kladd",
		"received": "Mottatt",
		"rejected": "Avslått",
		"ready": "Klar",
		"planned": "Planlagt",
		"unsuccessful": "Bomtur",
		"requested": "Forespurt",
		"accepted": "Akseptert",
		"selectStatus": "Velg status",
		"readyForPickup": "Klar for henting",
		"loaded": "Lastet",
		"unloaded": "Losset",
		"goodsTypes": "Godstyper"
	}
}
</i18n>
<template>
	<div class="filter-content">
		<t-form-group>
			<goods-types-select
				:label="$t('goodsTypes')"
				:selectedItems="selectedGoodsTypes"
				@change="onAddGoodsType"
			/>
			<t-tag-container
				v-if="selectedGoodsTypes.length > 0"
				:items="selectedGoodsTypes"
				displayKey="name"
				@change="onSetGoodsType"
			/>
		</t-form-group>

		<OperationalStatusFormInput
			:selectedItems="selectedStatuses"
			relative
			@change="onAddStatus"
		>
			<template v-slot:displayedValue="{popoverShow}">
				{{ popoverShow ? $t('selectStatus') : $tc('statusSelected', selectedStatuses.length)}}
			</template>

			<template #after>
				<t-tag-container
					v-if="selectedStatuses.length > 0"
					:items="selectedStatuses"
					@change="onSetStatus"
				>
					<template v-slot="{item}">
						<div style="display: flex; align-items: center; justify-content: flex-start;">
							<t-status-color-dot :color="getStatusColor(item)"/>
							<div style="margin-left: 5px;">{{getStatusText(item)}}</div>
						</div>
					</template>
				</t-tag-container>
			</template>
		</OperationalStatusFormInput>
	</div>
</template>

<script>
import { statuses } from '@/core';
import GoodsTypesSelect from '@/modules/goodsTypes/GoodsTypesSelect';
import OperationalStatusFormInput from '@/modules/operationalStatus/OperationalStatusFormInput';

export default {
	components: { GoodsTypesSelect, OperationalStatusFormInput },
	props: {
		value: { type: [ String, Number, Object ] },
		columnDefinition: {
			type: Object,
			required: true
		},
		customFilterStorage: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			selectedGoodsTypes: [],
			selectedStatuses: []
		};
	},
	mounted() {
		if (this.customFilterStorage.selectedGoodsTypes)
			this.selectedGoodsTypes = this.customFilterStorage.selectedGoodsTypes;
		if (this.customFilterStorage.selectedStatuses)
			this.selectedStatuses = this.customFilterStorage.selectedStatuses;
	},
	methods: {
		// return result like filterfactory
		getFilterFunc() {
			return (item) => (this.selectedGoodsTypes.length === 0 || this.selectedGoodsTypes.some(x => x.id === item['goodsType'])) &&
				(this.selectedStatuses.length === 0 || this.selectedStatuses.some(x => x === item['status']));
		},
		onAddGoodsType(tag) {
			let alreadyAdded = this.selectedGoodsTypes.some(x => x.id === tag.id);
			if (alreadyAdded) return;
			this.selectedGoodsTypes.push(tag);
			this.$set(this.customFilterStorage, 'selectedGoodsTypes', this.selectedGoodsTypes);
		},
		onSetGoodsType(list) {
			this.selectedGoodsTypes = list;
			this.$set(this.customFilterStorage, 'selectedGoodsTypes', this.selectedGoodsTypes);
		},
		onAddStatus(tag) {
			let alreadyAdded = this.selectedStatuses.some(x => x === tag);
			if (alreadyAdded) return;
			this.selectedStatuses.push(tag);
			this.$set(this.customFilterStorage, 'selectedStatuses', this.selectedStatuses);
		},
		onSetStatus(list) {
			this.selectedStatuses = list;
			this.$set(this.customFilterStorage, 'selectedStatuses', this.selectedStatuses);
		},
		getStatusText(status) {
			return this.$t(statuses.operational(status));
		},
		getStatusColor(status) {
			return statuses.color(status);
		},
	},
};
</script>
<style lang="scss" scoped>
.filter-content {
	display: grid;
	grid-auto-rows: minmax(min-content, max-content);
	grid-template-columns: 100%;
	row-gap: 20px;
	margin-bottom: 20px;
}
</style>
